export class LoanLodeStarQuestionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLodeStarQuestions({ loanId }) {
    return this.#http.get(`/loan/${loanId}/lodestar-questions/answers`);
  }

  async editLodeStarQuestions({ loanId, answers, recalculateFees }) {
    return this.#http.put(`/loan/${loanId}/lodestar-questions/answers`, {
      answers,
      recalculateFees,
    });
  }
}
